import { AircraftDto } from '@app/Models/WebApiModels';
import { DateTimeService } from '@app/Services/DateTimeService';

export class AircraftHelper {
    // In service "now": InServiceDateFrom is on/before today and InServiceDateTo is empty or on/after today.
    // Legacy rows hold a sentinel min-value date (year <= 1) for a missing "In Service From"; treat it as unset.
    public static isInServiceNow(a: AircraftDto): boolean {
        const toMidnight = (value?: Date): number | null => {
            if (!value) return null;
            const d = value instanceof Date ? value : new Date(value);
            if (!DateTimeService.isValidDate(d) || d.getUTCFullYear() <= 1) return null;
            return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
        };

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
        const from = toMidnight(a.inServiceDateFrom);
        const to = toMidnight(a.inServiceDateTo);

        if (from !== null && from > today) return false;
        if (to !== null && to < today) return false;
        return true;
    }
}
